import {Backdrop, CircularProgress} from '@mui/material'
import React from 'react'

const PageLoader = ({show = false}) => {
    return (
        <Backdrop open={show} sx={{zIndex: '100 !important'}}>
            <CircularProgress sx={{color: 'white'}} variant="indeterminate" size={50} />
        </Backdrop>
    )
}

export default PageLoader
